module.exports = __webpack_public_path__ + "static/media/gold-top.b913e368.svg";